// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//   <App />
//   // </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import OfflinePopup from "./component/givBee/popUp/OfflinePopup";
// import * as serviceWorker from "./registerServiceWorker";

ReactDOM.render(
  <>
    <App />
    <OfflinePopup />
    {/* <div id="iAmUniqueLoaderFCC" className="ptsloaderHide"></div> */}
    <div id="iAmUniqueModalAT" className="ptsmodal">
      <div id="iAmUniqueLoaderAT" className="ptsloader"></div>
    </div>
    <div className="overlay" id="overlay"></div>
    <div id="isServer">
      <serverErrorPopup />
    </div>
  </>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
